import { cva } from "class-variance-authority";

export { default as Asset } from "./Asset.vue";
export { default as Skeleton } from "./Skeleton.vue";

export const cardVariants = cva(
    [
        "group",
        "flex",
        "flex-col",
        "gap-3",
        "bg-primary",
        "hover:bg-primary_hover",
        "border-b",
        "border-b-secondary",
        "select-none",
        "cursor-pointer",
        "pl-2.5",
        "pr-4",
        "py-3",
        "transition-colors",
        "text-sm",
        "font-medium",
        "text-quaternary",
        "ltr:border-l-6",
        "rtl:border-r-6",
        "ltr:border-l-transparent",
        "rtl:border-r-transparent",
    ],
    {
        variants: {
            overdueOrExpired: {
                true: ["ltr:border-l-error", "rtl:border-r-error"],
            },
        },
    }
);
